<script lang="tsx" setup>
import useInstanceColumns from './columns'
import FilterContainer from '../filter/FilterContainer.vue'
import TextFilter from '../filter/TextFilter.vue'

const { columns, custom, all } = useInstanceColumns()
</script>

<template>
	<FilterContainer :columns="all" :custom="custom" bookmark="instances-bookmark">
		<div class="p-2 filter-col" v-if="columns.name.value.isVisible">
			<TextFilter data-test="name-filter-instance" v-model="columns.name.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.description.value.isVisible">
			<TextFilter data-test="description-filter-instance" v-model="columns.description.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.address.value.isVisible">
			<TextFilter data-test="address-filter-instance" v-model="columns.address.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.email.value.isVisible">
			<TextFilter data-test="email-filter-instance" v-model="columns.email.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.phone.value.isVisible">
			<TextFilter data-test="phone-filter-instance" v-model="columns.phone.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.contact.value.isVisible">
			<TextFilter data-test="contact-filter-instance" v-model="columns.contact.value"></TextFilter>
		</div>
	</FilterContainer>
</template>
